export default "__VITE_ASSET__38ae051d__"